var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Translate, I18NLink } from "../../I18N";
import { Icon } from "../../UI";
import { actions } from "../../BasicReducer";
import url from 'url';

function getDocumentUrlQuery(searchTerm, targetReference) {
  const query = {};
  if (searchTerm) {
    query.searchTerm = searchTerm;
  }
  if (targetReference) {
    query.ref = targetReference.get('_id');
  }
  return query;
}

export class ViewDocButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.stopPropagation();
    const { targetReference, openReferencesTab } = this.props;
    if (targetReference) {
      openReferencesTab();
    }
  }

  render() {
    const { sharedId, processed, searchTerm, file, targetReference, icon } = this.props;
    const isEntity = !file;

    const pathname = `/entity/${sharedId}`;
    const query = getDocumentUrlQuery(searchTerm, targetReference);
    const documentViewUrl = url.format({
      pathname,
      query
    });

    if (!processed && !isEntity) {
      return false;
    }

    return (/*#__PURE__*/
      _jsx(I18NLink, {
        to: documentViewUrl,
        className: "btn btn-default btn-xs view-doc",
        onClick: this.onClick }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: icon }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "View")
      ));

  }
}

ViewDocButton.defaultProps = {
  icon: 'angle-right',
  searchTerm: '',
  processed: false,
  targetReference: null
};











export function mapStateToProps(state, props) {
  return {
    searchTerm: props.storeKey ? state[props.storeKey].search.searchTerm : ''
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openReferencesTab: () => (_dispatch) =>
      _dispatch(actions.set('viewer.sidepanel.tab', 'references'))
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewDocButton);